import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "effects-carousel" }
const _hoisted_2 = {
  key: 0,
  class: "effects-carousel__button effects-carousel__button-left"
}
const _hoisted_3 = { class: "effects-carousel__item-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "effects-carousel__button effects-carousel__button-right"
}

import { AvailableEffect, EffectName } from '@/static/effectName'
import ChevronRight from '@/assets/ChevronRight.svg'
import ChevronLeft from '@/assets/ChevronLeft.svg'
import PictureHelper from './PictureHelper.vue'
import { computed, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EffectsCarousel',
  props: {
    effects: null,
    activeEffect: null
  },
  emits: ["selectEffect"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'selectEffect', effect: AvailableEffect): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  effects: AvailableEffect[]
  activeEffect: EffectName
};

_useCssVars(_ctx => ({
  "b99062a6": (_unref(carouselOffset))
}))



const setInitialCurrentPage = () => {
  currentPage.value = Math.floor(props.effects.findIndex(effect => effect.name === props.activeEffect) / effectsPerPage)
}

watch(() => props.effects, () => {
  setInitialCurrentPage()
}, { immediate: true })



const currentPage = ref(0)
const effectsPerPage = 5
const numberOfPages = computed(() => Math.ceil(props.effects.length / effectsPerPage))
const carouselOffset = computed(() => currentPage.value * -251 + 'px')
const showButtonLeft = computed(() => currentPage.value !== 0)
const showButtonRight = computed(() => currentPage.value !== (numberOfPages.value - 1))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showButtonLeft))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(ChevronLeft), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (currentPage.value--))
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.effects, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["effects-carousel__item", {'effects-carousel__item--active': item.name === __props.activeEffect}]),
          key: item.name,
          onClick: ($event: any) => (emits('selectEffect', item))
        }, [
          _createVNode(PictureHelper, {
            class: "effects-carousel__item-image",
            "image-name": `${item.thumbnail}-small`,
            densities: ['1x','2x'],
            formats: ['webp', 'jpg']
          }, null, 8, ["image-name"])
        ], 10, _hoisted_4))
      }), 128))
    ]),
    (_unref(showButtonRight))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_unref(ChevronRight), {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (currentPage.value++))
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})